import React from "react";
import { toast } from "sonner";
import { Copy, Download, KeyRound } from "lucide-react";

export function RecoveryCodes({ codes, onDone, doneLabel = "I've saved my codes" }) {
  const text = codes.join("\n");
  const copy = () => { navigator.clipboard.writeText(text); toast.success("Recovery codes copied"); };
  const download = () => {
    const blob = new Blob(
      [`Patria Count — recovery codes\nKeep these somewhere safe. Each code works ONCE.\n\n${text}\n`],
      { type: "text/plain" }
    );
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "patria-recovery-codes.txt"; a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <div className="fadeup" data-testid="recovery-codes">
      <div className="flex items-center gap-2 mb-2 text-[color:var(--olive)]"><KeyRound size={18} /><span className="font-semibold">Save your recovery codes</span></div>
      <p className="text-sm text-[color:var(--ink-2)] mb-3">Store these somewhere safe. Each code can be used <b>once</b> to sign in if you lose your authenticator. They won't be shown again.</p>
      <div className="grid grid-cols-2 gap-2 p-4 rounded-lg bg-[color:var(--cream)] border border-[color:var(--line)] font-mono text-sm">
        {codes.map((c) => <div key={c} data-testid="recovery-code">{c}</div>)}
      </div>
      <div className="flex gap-2 mt-4">
        <button className="btn btn-ghost h-10" onClick={copy} data-testid="rc-copy"><Copy size={15} /> Copy</button>
        <button className="btn btn-ghost h-10" onClick={download} data-testid="rc-download"><Download size={15} /> Download</button>
      </div>
      {onDone && <button className="btn btn-primary w-full mt-4" onClick={onDone} data-testid="rc-done">{doneLabel}</button>}
    </div>
  );
}
